import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (11 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisTroyi = {
  TroyiAdminStats(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/troyi-admin-stats`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },
  TroyiAdminConversations(token, page = 1, limit = 25, search = "", opts = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/troyi-admin-conversations`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { page, limit, search, ...opts },
    });
  },
  TroyiAdminConversation(token, conversationId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/troyi-admin-conversation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { conversation_id: conversationId },
    });
  },
  ChatRooms(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-rooms`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },
  ChatCustomerSearch(token, q) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-customer-search`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { q },
    });
  },
  ChatRoomUsers(token, roomId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-room-users`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { room_id: roomId },
    });
  },
  ChatHistory(token, roomId, beforeId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-history`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { room_id: roomId, before_id: beforeId || 0, limit: 50 },
    });
  },
  ChatSend(token, roomId, body, attachment) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-send`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { room_id: roomId, body, attachment: attachment || null },
    });
  },
  ChatUpload(token, roomId, file, name, extension) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-upload`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { room_id: roomId, file, name, extension },
    });
  },
  ChatMarkRead(token, roomId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-mark-read`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { room_id: roomId },
    });
  },
  ChatUnread(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/chat-unread`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },
};

export default servisTroyi;
